<template>
    <div 
        class="folder-block"
        @click.stop="openGroup(folder.id)"
        :class="[
        { bright: $store.state.system_settings.color_palette == 0 },
        { medium: $store.state.system_settings.color_palette == 1 },
        { blank: $store.state.system_settings.color_palette == 2 },
        { 'colors-open': activeOptionMenu == folder.id && colorExpanded },
        ]"
        :key="'index-'+folder.id"
        :id="folder.id"
        :style="getFolderStyle(folder, rowIndex)"
    >
        <div class="folder-block-cover"></div>
        <div
            class="option-dots"
            v-if="showSettings && folder.id != -1 && showEditOptions(folder) && type=='edit'"
            @click.stop="
                activeOptionMenu == folder.id
                ? closeMenus()
                : activeOptionMenu == -50
                ? (activeOptionMenu = folder.id)
                : closeMenus() && (activeOptionMenu = -50)
            "
        >
            <OptionDotsSvg class="themable"/>
        </div>
        <div
            v-if="
                (showEditOptions(folder)) &&
                activeOptionMenu == folder.id &&
                !colorExpanded &&
                !renameMode
                && type == 'edit'
            "
            v-click-outside-2="closeMenus"
            class="option-menu"
            :class="{short: (showEditOptions(folder)) && $store.state.user_role != 'admin'}"
            @click.stop
        >
            <div class="color option-block" @click.stop="colorMode(folder)" v-if="(showEditOptions(folder))">
                <div class="circle"></div>
            </div>
            <div class="group option-block" @click.stop="openGroupSide(folder)" v-if="$store.state.user_role == 'admin' || hasPermission('users.assign_trainings')">
                <HomeEditOpenGroupSvg class="stroke" />
            </div>
            <div class="gallery option-block" @click.stop="uploadFolderImg(folder)" v-if="(showEditOptions(folder))">
                <ItemGallerySvg />
            </div>
            <div class="pencil option-block" @click.stop="enterRename(folder)" v-if="(showEditOptions(folder))">
                <EditFolderNameSvg />
            </div>
            <div class="trash option-block" @click.stop="deleteGroup(folder)" v-if="$store.state.user_role == 'admin'">
                <GroupFolderTrashSvg />
            </div>
          
        </div>
        <div
            class="option-menu color"
            v-click-outside-2="closeMenus"
            v-else-if="
                activeOptionMenu == folder.id &&
                colorExpanded &&
                !renameMode
                && type == 'edit'
            "
            @click.stop
        >
            <input
                class="color-input"
                :class="[
                { bright: $store.state.system_settings.color_palette == 0 },
                { medium: $store.state.system_settings.color_palette == 1 },
                { blank: $store.state.system_settings.color_palette == 2 },
                ]"
                type="range"
                min="0"
                max="11"
                step="0.1"
                v-model="colorHue"
                @input.stop="updateColorHue(folder)"
                @click.stop=""
                :style="{
                '--thumb-color': `${
                    folder.color_hue != null
                    ? folder.color_hue
                    : colorPalettes[
                        $store.state.system_settings.color_palette
                        ][0]
                }`,
                }"
            />
        </div>
        <textarea
            class="folder-name-input"
            ref="nameInput"
            v-if="renameMode == true && activeOptionMenu == folder.id"
            @blur="finishEditing"
            @input="changeGroupName(folder)"
            @click.stop=""
            v-model="groupName"
            spellcheck="false"
        />
        <span
            v-else
            class="folder-name"
            :class="{
                darkLetters:
                folder.id == -1 &&
                $store.state.system_settings.color_palette == 0,
            }"
        >
            {{ folder.name }}
        </span
        >
        <div
            class="bottom-line"
            v-if="folder.trainings"
            :class="[
                { end: !folder.trainings.length && !folder.trainings },
                {
                darkLetters:
                    folder.id == -1 &&
                    $store.state.system_settings.color_palette == 0,
                },
            ]"
        >
          <span class="training-count" v-if="type == 'view' && folder.ended_percent != undefined && folder.trainings.length != 0"
            >{{ toLocal("groups.finished_trainings") }}
            {{ folder.ended_percent != null ? folder.ended_percent.toFixed(0) : 0 }} %</span
          >
          <span class="training-count" v-else-if="folder.trainings != 0 || Array.isArray(folder.trainings) && folder.trainings.length > 0 "
              >{{ toLocal("groups.training_count") }}
              {{ Array.isArray(folder.trainings)  ? folder.trainings.length : folder.trainings }}</span
          >
        <div class="arrow-container"><ArrowRightFadeSvg class="themable"/></div>
        </div>
        <div class="bottom-bar" v-if="type=='view' && folder.ended_percent != undefined">
            <div
              class="inner-bar"
              :style="`width: ${folder.ended_percent != null ? folder.ended_percent.toFixed(
                0
              ) : 0}%; border-top-right-radius: ${
                (folder.ended_percent != null && folder.ended_percent.toFixed(0) == 100) ? '0px' : '16px'
              }`"
            ></div>
          </div>
    </div>
</template>

<script>
import PlusNarrowSvg from "@/assets/images/icons/plus-narrow-white.svg?inline";
import GroupSearchSvg from "@/assets/images/icons/group-search-black.svg?inline";
import LoadingBubbleSvg from "@/assets/images/icons/loading-bubble.svg?inline";
import ArrowRightFadeSvg from "@/assets/images/icons/arrow-right-fade.svg?inline";
import HomeEditOpenGroupSvg from "@/assets/images/icons/homeEdit/home-edit-group-widthless.svg?inline";
import OptionDotsSvg from "@/assets/images/icons/option-dots.svg?inline";
import EditFolderNameSvg from "@/assets/images/icons/edit-folder-name.svg?inline";
import GroupFolderTrashSvg from "@/assets/images/icons/group-folder-trash.svg?inline";
import VueScrollTo from "vue-scrollto";
import TrainingItemGallerySvg from "@/assets/images/icons/training-item-gallery.svg?inline";
import ItemGallerySvg from "@/assets/images/icons/gallery-img-icon.svg?inline";
import axios from 'axios';
export default {
    props:{
        folder: Object,
        type: {
            type: String,
            default: "edit",
        },
        options: Object,
        rowIndex: Number,
        trainingRowGroups: Array,
        showSettings: Boolean,
    },
    components: {
        OptionDotsSvg,
        EditFolderNameSvg,
        GroupFolderTrashSvg,
        PlusNarrowSvg,
        GroupSearchSvg,
        LoadingBubbleSvg,
        ArrowRightFadeSvg,
        HomeEditOpenGroupSvg,
        TrainingItemGallerySvg,
        ItemGallerySvg
    },
    watch:{
        activeOptionMenu(){
            if(this.activeOptionMenu == -50){
                this.$emit('toggleDrag', false)
            }
            else if(this.renameMode){
                this.$emit('toggleDrag', false)
            }
            else{
                this.$emit('toggleDrag', true)
            }
        }
    },
    data(){
        return{
            deletingStatus: "",
            multiChoiceInfo: {
                type: "multiChoice",
                text: "modal.group_with_trainings",
                undertext: "modal.choose_what_to_do",
                multiChoiceYes: "modal.transfer_to_another",
                multiChoiceNo: "modal.delete_forever",
            },
            multiChoiceOpened: false,
            isFolderCreating: false,
            searchTerm: "",
            isHeaderInView: true,
            colorSliderPos: 0,
            colorHue: 5.5,
            groupName: "",
            addingTraining: false,
            addingNewGroup: false,
            trainingGroupsClone: [],
            trainingGroups: [],
            searchTrainingGroups: [],
            loaded: false,
            selectedTraining: {},
            isSearching: false,
            searchInputValue: "",
            trainingRows: 0,
            activeOptionMenu: -50,
            colorExpanded: false,
            renameMode: false,
            deleteModalOpened: false,
            infoModalOpened: false,
            changedFolders: [],
            selectedView: 1,
            galleryOpen: false,
            colorPalettes: [
                [
                "rgba(230, 69, 69, 1)",
                "rgba(229, 115, 0, 1)",
                "rgba(191, 143, 0, 1)",
                "rgba(100, 153, 46, 1)",
                "rgba(46, 153, 46, 1)",
                "rgba(46, 153, 100, 1)",
                "rgba(46, 153, 153, 1)",
                "rgba(69, 150, 229, 1)",
                "rgba(69, 69, 229, 1)",
                "rgba(150, 69, 230, 1)",
                "rgba(153, 46, 153, 1)",
                "rgba(229, 69, 150, 1)",
                ],
                [
                "rgba(229, 115, 115, 1)",
                "rgba(229, 166, 103, 1)",
                "rgba(229, 229, 103, 1)",
                "rgba(184, 229, 138, 1)",
                "rgba(138, 229, 138, 1)",
                "rgba(115, 229, 172, 1)",
                "rgba(115, 229, 229, 1)",
                "rgba(115, 172, 229, 1)",
                "rgba(138, 138, 229, 1)",
                "rgba(184, 138, 230, 1)",
                "rgba(229, 138, 229, 1)",
                "rgba(229, 138, 184, 1)",
                ],
                [
                "rgba(229, 184, 184, 1)",
                "rgba(229, 207, 184, 1)",
                "rgba(229, 229, 184, 1)",
                "rgba(207, 229, 184, 1)",
                "rgba(184, 229, 184, 1)",
                "rgba(184, 229, 207, 1)",
                "rgba(184, 229, 229, 1)",
                "rgba(184, 207, 229, 1)",
                "rgba(184, 184, 229, 1)",
                "rgba(207, 184, 229, 1)",
                "rgba(229, 184, 229, 1)",
                "rgba(229, 184, 207, 1)",
                ],
            ],
            color1: "rgba(230, 69, 69, 1)",
            color2: "rgba(229, 115, 0, 1)",
            windowWidth: window.innerWidth,
            movingTrainings: false,
            selectedFolder: null,
            selectedMode: 1,
            requestController: null,
            initialFolderHue: '',
            initialFolderName: '',
            dynamicMode: this.$store.state.system_settings.grid_dynamic_size ? this.$store.state.system_settings.grid_dynamic_size  : 0,
        }
    },
 
    methods:{
        getFolderStyle(folder, rowIndex) {
            let style = '';
            if (this.dynamicMode != 0) {
                // style += `grid-column: ${this.trainingRowGroups[rowIndex].length == 1 && this.windowWidth >= 1200
                //     ? '7/'
                //     : this.windowWidth <= 1200 && this.windowWidth > 900
                //       ? ''
                //       : this.windowWidth <= 900 && this.windowWidth > 768 ? '2/' : ''
                //   }span ${folder.columnSize};`
                if(this.options && this.options.minWidth){
                  style += `width: ${this.options.minWidth}%;`;
                }
                else{
                  style += `width: ${folder.columnSize}%;`;
                }
            }else if((rowIndex != undefined) && this.trainingRowGroups){
                style += `grid-column: ${this.trainingRowGroups[rowIndex].length == 1 && this.windowWidth >= 1200
                    ? '7/'
                    : this.windowWidth <= 1200 && this.windowWidth > 900
                    ? ''
                    : this.windowWidth <= 900 && this.windowWidth > 768 ? '' : ''
                }span ${folder.columnSize};`
            }
            else if(this.options && this.options.minWidth){
              style += `width: ${this.options.minWidth}%;`;
            }
           
            try{
                if(folder['data'] && typeof folder['data'] == 'string'){
                folder['data'] = JSON.parse(folder['data'])
                }
            }catch(e){
                console.log(e);
            }
            if(folder['data'] && folder['data']['image']){
                style += `background-image: url(${this.$store.state.api_uploads_link}/${folder['data']['image']});`
                style += `background-color: #ffffff;`
            }else{
                style+=`background-color: ${
                folder.color_hue != null
                    ? folder.color_hue
                    : this.colorPalettes[this.$store.state.system_settings.color_palette]
                    ? this.colorPalettes[this.$store.state.system_settings.color_palette][0]
                    : this.colorPalettes[0][0]
                };`
            }
            if (this.$store.state.system_settings.custom_style && this.$store.state.system_settings.custom_style.training_grid_style) {
                if (this.$store.state.system_settings.custom_style.training_grid_style.color) {
                style += `color: ${this.$store.state.system_settings.custom_style.training_grid_style.color};`
                }
                if (this.$store.state.system_settings.custom_style.training_grid_style['font-weight']) {
                style += `font-weight: ${this.$store.state.system_settings.custom_style.training_grid_style['font-weight']};`
                }
                if (this.$store.state.system_settings.custom_style.training_grid_style['font-size']) {
                style += `font-size: ${this.$store.state.system_settings.custom_style.training_grid_style['font-size']};`
                }
            }
            return style
        },
        openGroup(id) {
            this.$emit('openGroup', id)
        },
        showEditOptions(folder) {
            if (this.$store.state.user_role == 'admin') return true;
            else if (this.$store.state.user_permissions
                && this.$store.state.user_permissions['trainings.edit_in_groups']
                && this.$store.state.user_permissions['trainings.edit_in_groups'].items
                && this.$store.state.user_permissions['trainings.edit_in_groups'].items.includes(folder.id)) {
                return true;
            }
            else if(folder.created_by == this.$store.state.user_id) return true;
            else {
                return false;
            }
        },
        closeMenus() {
            setTimeout(() => {
                if (this.activeOptionMenu != -50) {
                   
                    this.colorExpanded = false;
                    this.activeOptionMenu = -50;
                    this.groupName = "";
                    this.renameMode = false;
                    
                    this.saveGroupFolder(this);
                }
            }, 200);
        },
/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Activates the color mode for a folder, expanding the color options.
 * Initializes the color hue based on the folder's current color settings.
 * If the folder has no color hue, sets the default hue to 0.
 * If the folder has a color slider position, uses it to set the color hue.
 *
 * @param {Object} folder - The folder object containing color properties.
 */

/*******  09451f60-aef3-4830-87d6-6ada0ab46754  *******/
        colorMode(folder) {
            this.initialFolderHue = this._.cloneDeep(folder.color_hue);
            this.colorExpanded = true;
            if (folder.color_hue == null) {
                this.colorHue = 0;
            } else {
                if (folder.color_slider_pos != null) {
                this.colorHue = folder.color_slider_pos;
                }
            }
        },
        openGroupSide(folder){
            this.$emit("openGroupSide", folder);
           
        },
        uploadFolderImg(folder){
            this.$emit("uploadFolderImg", folder);
       
        },
        enterRename(folder) {
            this.initialFolderName = this._.cloneDeep(folder.name);
            this.groupName = "";
            this.groupName = folder.name;
            this.renameMode = true;
            this.$nextTick(() => this.$refs.nameInput.focus());
        },
        deleteGroup(folder) {
            this.$emit("deleteGroup", folder);
        },
        updateColorHue(folder) {
            window.requestAnimationFrame(() => {
                this.changeGroupHue(folder);
            });
            if(this.activeOptionMenu != -50){
                this.saveGroupFolder(this);
            }
        },
        saveGroupFolder: _.debounce((self)=>{
            let folder = self.folder;
            if (
                folder.name === self.initialFolderName &&
                folder.color_hue === self.initialFolderHue
            ) {
                return;
            } 
            else {
                axios
                .post(
                    `${self.$store.state.api_link}/training_group/editInfo/${folder.id}`,
                    {
                    name: folder.name,
                    color_pos: folder.color_hue != self.initialFolderHue ? self.colorHue : null,
                    },
                    self.$store.getters.axiosConfig()
                )
                .then((response) => {
                })
                .catch((error) => {
                    self.$store.commit("handleError", { error: error });
                });
            }
        }, 500),
        changeGroupHue(folder, optionalColor) {
            if (optionalColor != undefined) {
                this.colorHue = optionalColor;
            }
            let colorGroup = Math.floor(
                this.colorHue %
                this.colorPalettes[this.$store.state.system_settings.color_palette]
                    .length
            );
            this.color1 =
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                colorGroup
                ];
            if (
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                colorGroup + 1
                ] == undefined
            ) {
                this.color2 ==
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                    this.colorPalettes[this.$store.state.system_settings.color_palette]
                    .length - 1
                ];
            } else {
                this.color2 =
                this.colorPalettes[this.$store.state.system_settings.color_palette][
                    colorGroup + 1
                ];
            }
            // this.colorHue /= 100;
            let color1Values = this.color1
                .replace("rgba(", "")
                .replace(")", "")
                .split(",");
            let color2Values = this.color2
                .replace("rgba(", "")
                .replace(")", "")
                .split(",");
            let copiedColor = this.colorHue;
            for (let i = 1; i <= copiedColor; ) {
                copiedColor -= 1;
            }
            let midwayValues = color1Values.map(
                (val, index) =>
                (1 - copiedColor) * parseInt(val) +
                copiedColor * parseInt(color2Values[index])
            );
            midwayValues[midwayValues.length - 1] = 1;
            let color = `rgba(${midwayValues
                .map((val) => Math.floor(val))
                .join(",")})`;
            if(!folder.color_hue){
                folder.color_hue = color;
                
            }
            if(folder.color_hue && !folder.color_hue.startsWith('#'))
                folder.color_hue = color;
        },
        changeGroupName(folder) {
            this.$set(folder, "name", this.groupName);
        },
        finishEditing() {
            this.closeMenus();
        },
    }
}
</script>

<style lang="scss" scoped>
.folder-block {
  min-height: 300px;
  min-width: 300px;
  max-width: 100%;
  background-color: rgb(97, 3, 3);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  position: relative;
  transition: 0.2s;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  &.bright {
    color: white;
    svg {
      &.themable{
        stroke: white;
      g {
        fill: white;
      }
      path {
        stroke: white;
      }
      }
    }
  }
  &.medium {
    color: #333333;
    color: #333333;
    svg {
      &.themable{
      g {
        fill: #333333;
      }
      path {
        stroke: #333333;
      }
      }
    }
  }
  &.blank {
    color: #333333;
    svg {
      &.themable{
      g {
        fill: #333333;
      }
      path {
        stroke: #333333;
      }
    }
    }
  }
  &.colors-open{
    &:hover {
    .folder-block-cover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.25s;
      background-color: initial;
      border-radius: 16px;
    }
    .bottom-line {
      .arrow-container {
        svg {
          opacity: 1;
        }
      }
    }
  }
  }
  @media (max-width: 421px) {
      min-width: 100%;
    min-height: 250px;
  }
  cursor: pointer;
  &:hover {
    .folder-block-cover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.25s;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 16px;
    }
    .bottom-line {
      .arrow-container {
        svg {
          opacity: 1;
        }
      }
    }
  }
}
.bottom-line {
  display: flex;
  width: 90%;
  justify-content: space-between;
  position: absolute;
  z-index: 1;
  bottom: 24px;
  left: 24px;
  cursor: pointer;
  .end{
    justify-content: flex-end;
  }
  .arrow-container {
    padding: 10px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 50%;
    justify-self: flex-end;
    svg {
      opacity: 0.5;
      transition: 0.5s;
    }
    &:hover {
      // background-color: hsla(0, 0%, 100%, 0.199);
      svg {
        opacity: 1;
      }
    }
  }
  &.end {
    justify-content: flex-end;
  }
}
.folder-name {
  width: 75%;
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 28px;
  height: 68%;
  cursor: pointer;
  word-wrap: break-word;
  overflow-y: hidden;
}
.folder-name-input {
  width: 70%;
  height: 70%;
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 28px;
  word-wrap: break-word;
  background-color: transparent;
  color: white;
  border: none;
  resize: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  text-decoration: underline;
  font-family: var(--main-site-font);
  &:focus {
    outline: none;
  }
}
.bottom-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
  min-height: 20px;
  border-bottom-right-radius: 16px;
  .inner-bar {
    min-height: 20px;
    border-bottom-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    background: rgba(255, 255, 255, 0.2);
  }
}
.option-dots {
  position: absolute;
  top: 20px;
  right: 16px;
  height: 42px;
  width: 48px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  border-radius: 20px;
  transition: 0.5s;
  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
    g {
      opacity: 0.5;
      transition: 0.5s;
    }
  }
  &:hover {
    svg {
      g {
        opacity: 1;
      }
    }
  }
}
.training-count {
  font-size: 20px;
  display: flex;
  align-items: center;
}
.option-menu {
  z-index: 2;
  position: absolute;
  right: 18px;
  top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48px;
  max-height: 100%;
  color: black;
  background-color: rgba(249, 249, 249, 1);
  transform-origin: top;
  animation: expand 0.5s;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
    overflow: hidden;
  &.color {
    height: 80%;
    justify-content: center;
  }
  &.short{
    height: fit-content;
    animation: none;
  }
  .color-input {
    &.bright {
      background: linear-gradient(
        90deg,
        #e64545 0%,
        #e57300 10.33%,
        #b28500 19.44%,
        #64992e 28.3%,
        #2e992e 37.29%,
        #2e9964 45.88%,
        #2e9999 54.61%,
        #4596e5 63.72%,
        #4545e5 72.45%,
        #9645e6 81.95%,
        #992e99 91.2%,
        #e54596 100%
      );
    }
    &.medium {
      background: linear-gradient(
        90deg,
        #e57373 0%,
        #e5a667 10.33%,
        #e5e567 19.44%,
        #b8e58a 28.3%,
        #8ae58a 37.29%,
        #73e5ac 45.88%,
        #73e5e5 54.61%,
        #72ace5 63.72%,
        #8a8ae5 72.45%,
        #b88ae6 81.95%,
        #e58ae5 91.2%,
        #e58ab8 100%
      );
    }
    &.blank {
      background: linear-gradient(
        90deg,
        #e5b8b8 0%,
        #e5cfb8 10.33%,
        #e5e5b8 19.44%,
        #cfe5b8 28.3%,
        #b8e5b8 37.29%,
        #b8e5cf 45.88%,
        #b8e5e5 54.61%,
        #b8cfe5 63.72%,
        #b8b8e5 72.45%,
        #cfb8e5 81.95%,
        #e5b8e5 91.2%,
        #e5b8cf 100%
      );
    }
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    width: 209px;
    max-height: 12px;
    -webkit-transform: rotate(90deg);
    // max-width: 12px;
    -webkit-appearance: none;
    cursor: pointer;
    &::-webkit-slider-runnable-track {
      width: 209px;
      max-width: 209px;
      height: 12px;
      // transform: r;
      // -webkit-transform: rotate(90deg);
    }
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-top: -6px;
      border: 3px solid #f9f9f9;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
      background-color: var(--thumb-color);
    }
    &::-moz-range-thumb {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-top: -6px;

      border: 3px solid #f9f9f9;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
      background-color: var(--thumb-color);
    }
  }
  .option-block {
    width: 100%;
    min-height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.group{
      svg{
        width: 50%;
      }
    }
    &.gallery{
      svg{
        width: 70%;
      }
    }
    &:hover {
      background-color: #d9d9d9;
      &.group{
        svg path{
          fill: white;
        }
      }
    }
    &.color {
      .circle {
        width: 29px;
        background: conic-gradient(
          at 50% 50%,
          red,
          #ff0 16.66%,
          #0f0 33.33%,
          #0ff 50%,
          #00f 66.66%,
          #f0f 83.33%,
          red
        );
        height: 29px;
        border-radius: 50%;
      }
    }
  }
}
@keyframes expand {
  from {
    max-height: 0%;
  }
  to {
    max-height: 100%;
  }
}
</style>